import { render, staticRenderFns } from "./DiceNav.vue?vue&type=template&id=430fda72&scoped=true&"
import script from "./DiceNav.vue?vue&type=script&lang=js&"
export * from "./DiceNav.vue?vue&type=script&lang=js&"
import style0 from "./DiceNav.vue?vue&type=style&index=0&id=430fda72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430fda72",
  null
  
)

export default component.exports